import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { useRealtime } from "../../context/RealtimeContext";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "");
const tx = (t) => (t?.ok ? ["Transmise", "text-emerald-700"] : t?.ok === false ? [`Échec : ${t.error}`, "text-rose-700"] : ["En cours…", "text-slate-500"]);

export function PtiAlarmsList() {
  const [items, setItems] = useState([]);
  const { lastEvent } = useRealtime();
  const load = () => http.get("/pti/alarms").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  useEffect(() => { if (lastEvent?.event === "pti_changed") load(); }, [lastEvent]);
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto" data-testid="pti-alarms-list">
      <div className="px-4 py-3 font-bold border-b border-slate-100">Historique des alarmes PTI</div>
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
          <tr><th className="text-left px-4 py-2">Date</th><th className="text-left px-4 py-2">Agent</th><th className="text-left px-4 py-2">Alarme</th><th className="text-left px-4 py-2">Position</th><th className="text-left px-4 py-2">Télésurveillance</th><th className="text-left px-4 py-2">Suite</th></tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {items.length === 0 && <tr><td colSpan={6} className="p-5 text-center text-slate-500">Aucune alarme.</td></tr>}
          {items.map((a) => {
            const [t, cls] = tx(a.transmission);
            return (
              <tr key={a.id} data-testid={`pti-alarm-${a.id}`}>
                <td className="px-4 py-2 whitespace-nowrap">{fmt(a.created_at)}</td>
                <td className="px-4 py-2">{a.agent_name}</td>
                <td className="px-4 py-2 font-semibold">{a.label}</td>
                <td className="px-4 py-2">{a.lat != null ? <a className="text-sky-700 hover:underline" target="_blank" rel="noreferrer" href={`https://www.openstreetmap.org/?mlat=${a.lat}&mlon=${a.lon}#map=18/${a.lat}/${a.lon}`}>Carte</a> : "—"}</td>
                <td className={`px-4 py-2 ${cls}`}>{t}</td>
                <td className="px-4 py-2">{a.status === "cancelled" ? `Annulée par l'agent (${a.cancel_reason === "test" ? "test" : "erreur de manipulation"})` : "Prise en charge par la télésurveillance"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
